import { LayoutGrid, List as ListIcon, SlidersHorizontal } from "lucide-react";
import { ListingCard, ListingRow } from "@/components/Listings";

export function CategoryToolbar({ total, view, setView, onToggleFilters }) {
  const viewBtn = (mode) => `p-2 ${view === mode ? "bg-black text-white" : "bg-white"}`;
  return (
    <div className="flex items-center gap-3 font-mono-data text-xs uppercase mt-2 md:mt-0 w-full md:w-auto">
      <span className="text-gray-600">{total} listings</span>
      <button data-testid="mobile-filters-toggle" onClick={onToggleFilters} className="md:hidden ml-auto border-2 border-black px-3 py-2 flex items-center gap-1 bg-white hover:bg-black hover:text-white">
        <SlidersHorizontal size={14} /> Filters
      </button>
      <div className="flex border-2 border-black">
        <button data-testid="view-grid-btn" onClick={() => setView("grid")} className={viewBtn("grid")}><LayoutGrid size={14} /></button>
        <button data-testid="view-list-btn" onClick={() => setView("list")} className={`${viewBtn("list")} border-l-2 border-black`}><ListIcon size={14} /></button>
      </div>
    </div>
  );
}

export function ListingResults({ items, view, favs, onToggleFavorite }) {
  if (items.length === 0) {
    return <div className="border-2 border-black p-12 text-center font-mono-data text-sm uppercase text-gray-500">No listings match these filters.</div>;
  }
  if (view === "list") {
    return <div className="border-2 border-black">{items.map((l) => <ListingRow key={l.listing_id} listing={l} />)}</div>;
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((l) => <ListingCard key={l.listing_id} listing={l} isFavorite={favs.includes(l.listing_id)} onToggleFavorite={onToggleFavorite} />)}
    </div>
  );
}
